import { render, staticRenderFns } from "./AddOrEditQuestionInfo.vue?vue&type=template&id=dfc92f54&scoped=true"
import script from "./AddOrEditQuestionInfo.vue?vue&type=script&lang=js"
export * from "./AddOrEditQuestionInfo.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditQuestionInfo.vue?vue&type=style&index=0&id=dfc92f54&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc92f54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfc92f54')) {
      api.createRecord('dfc92f54', component.options)
    } else {
      api.reload('dfc92f54', component.options)
    }
    module.hot.accept("./AddOrEditQuestionInfo.vue?vue&type=template&id=dfc92f54&scoped=true", function () {
      api.rerender('dfc92f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/questionnaire/question/sub/AddOrEditQuestionInfo.vue"
export default component.exports